import { useRef } from 'react';
import _ from '@lodash';

const useDebounce = (func, wait, options) => useRef(_.debounce(func, wait, options)).current;

export default useDebounce;
